<script>
    let {
        value,
        rowIndex,
        rowId,
        instructKey
    } = $props();

    let data = $derived(value);
</script>

{#if data}
    <a
        href={`/property/${data.target_object_type}/${encodeURIComponent(data["kind"])}`}
        title={data.kind}
    >
        {data.kind}
    </a>
{/if}

<style>
</style>
